import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams, useOutletContext } from "react-router-dom";
import { useAlert } from "react-alert";
import { ResearcherContext } from "../../../../ResearcherContext";

import Scheduling from "../components/Scheduling";

// Api Calls



function SchedulingCreatePage(props) {
    const [missionType, loadingMissionType, nextPage, backPage] = [props.missionType, props.loadingMissionType, props.nextPage, props.backPage]

    return (
        <div className="create-mission-primary-content-container">
            <Scheduling savePath={nextPage} backPath={backPage} saveText="Next" />
        </div>
    )

}

export default SchedulingCreatePage;